<script>
import App from "../App.svelte";

    export let onClose;
    export let isOpen;
    export let component;
    export let props;
</script>

<div
    class="dialog"
    class:hidden={!isOpen}
    on:click={() => onClose()}
>
    <div class="dialog-box">
        <svelte:component this={component} {...props}/>
    </div>
</div>

<style>
    .dialog {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        color: black;
        top: 0px;
        z-index: 30;
    }
    .dialog-box {
        background-color: rgba(255, 255, 255, 0.95);
        padding: 20px;
        border-radius: 5px;
        max-width: 55vw;
        max-height: 88vh;
        overflow: scroll;
    }
    .hidden {
        display: none;
    }
</style>